import Cookies from 'js-cookie'
/**
 * Cookies.set('key', 'value')
 * Cookies.set('key', 'value', { expires: 7}) //设置7天过期
 * Cookies.set('key', 'value', { expires: 7, path: ''}) //设置对当前页面的路径
 */

const TOKEN_KEY = 'bgrimmMTC_token';
const EXPIRES_SEC = 15 * 60;  // 过期时间：15分钟

export function getToken () {
  // 刷新token过期时间
  let tokenVal = Cookies.get(TOKEN_KEY);
  tokenVal && setToken(tokenVal);
  return Cookies.get(TOKEN_KEY);
}

export function setToken (value) {
  let expires = new Date(new Date() * 1 + EXPIRES_SEC * 1000);
  return Cookies.set(TOKEN_KEY, value, { expires });
}

export function removeToken () {
  return Cookies.remove(TOKEN_KEY);
}



// WEBPACK FOOTER //
// ./src/axios/cookies.js